import { url, header } from "../../apis/Index";
import axios from "axios";

export const getAcTerms = () => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_AC_TERM_INFO",
      fetchingLoaders: true,
    });
    axios
      .get(`${url}/terms`, {
        headers: header,
      })
      .then((acTerms) => {
        dispatch({
          type: "GET_ACTERMS",
          acTerms,
        });
        dispatch({
          type: "GETTING_AC_TERM_INFO",
          fetchingLoaders: false,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GETTING_AC_TERM_INFO",
          fetchingLoaders: false,
        });
        dispatch({
          type: "SET_AC_TERM_MESSAGE",
          message: "Failed to get academic terms",
        });
      });
  };
};

export const createAcTerm = (newTerm, closeFormAfterAdding) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_AC_TERM_INFO",
      loader: true,
    });
    axios
      .post(`${url}/terms`, newTerm, {
        headers: header,
      })
      .then((acTerm) => {
        dispatch({
          type: "CREATE_ACTERM",
          acTerm,
        });
        dispatch({
          type: "SENDING_AC_TERM_INFO",
          loader: false,
        });
        closeFormAfterAdding();
      })
      .catch(() => {
        dispatch({
          type: "SENDING_AC_TERM_INFO",
          loader: false,
        });
        dispatch({
          type: "SET_AC_TERM_MESSAGE",
          message: "Failed to add academic term",
        });
      });
  };
};

export const updateAcTerm = (updatedAcTerm, id, closeFormAfterAdding) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_AC_TERM_INFO",
      loader: true,
    });
    axios
      .put(`${url}/terms/${id}`, updatedAcTerm, {
        headers: header,
      })
      .then((acTerm) => {
        dispatch({
          type: "UPDATE_ACTERM",
          acTerm,
        });
        dispatch({
          type: "SENDING_AC_TERM_INFO",
          loader: false,
        });
        closeFormAfterAdding();
      })
      .catch((error) => {
        dispatch({
          type: "SENDING_AC_TERM_INFO",
          loader: false,
        });
        dispatch({
          type: "SET_AC_TERM_MESSAGE",
          message: "Failed to update academic term",
        });
      });
  };
};

export const deleteAcTerm = (id) => {
  return (dispatch) => {
    dispatch({
      type: "DELETING_AC_TERM_INFO",
      deletingAction: {
        id: id,
        deleting: true,
      },
    });
    axios
      .delete(`${url}/terms/${id}`, {
        headers: header,
      })
      .then(() => {
        dispatch({
          type: "DELETE_ACTERM",
          id,
        });
        dispatch({
          type: "DELETING_AC_TERM_INFO",
          deletingAction: {
            id: null,
            deleting: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: "SET_AC_TERM_MESSAGE",
          message: "Failed to delete academic term",
        });
        dispatch({
          type: "DELETING_AC_TERM_INFO",
          deletingAction: {
            id: null,
            deleting: false,
          },
        });
      });
  };
};
